import React from 'react';
import SwitchRoundFlag from './SwitchRoundFlag';
var selfStyles = require('./SwitchRoundFlag.scss');
var SwitchRoundFlagFinalized = function (props) { return (React.createElement(SwitchRoundFlag, { round: props.round, field: 'isScoresFinalized', handlePatchRound: props.handlePatchRound, confirmMessageSetTrue: (React.createElement("div", { className: selfStyles.popconfirm },
        React.createElement("h3", null, "Confirm scores for round?"),
        React.createElement("p", null, "This will add a label to the scoreboard to show that scores have been verified by the Chief Judge."))), confirmMessageSetFalse: (React.createElement("div", { className: selfStyles.popconfirm },
        React.createElement("h3", null, "Unconfirm scores for round?"),
        React.createElement("p", null, "This will add a label to the scoreboard to show that the scores are still subjected to changes."))) })); };
export default SwitchRoundFlagFinalized;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/SwitchRoundFlagFinalized.tsx
// module id = 238
// module chunks = 0